<!-- @format -->

@if (
  {
    isMobileView: isMobileView$ | async,
    enrolment: enrolment$ | async,
  };
  as props
) {
  @if (courseUnitRealisation) {
    <sis-expandable
      [title]="(courseUnitRealisation.name | localizedString) + ' ' + (courseUnitRealisation.activityPeriod | localDateRange)"
      [level]="4"
      [variant]="'naked-dotted'">
      <ng-template sisExpandableCustomTitle>
        @if (props.enrolment) {
          <app-enrolment-status-badge [enrolment]="props.enrolment"></app-enrolment-status-badge>
        }
        @if (!props.enrolment) {
          <app-enrolment-period-badge [courseUnitRealisation]="courseUnitRealisation"></app-enrolment-period-badge>
        }
      </ng-template>
      @if (!props.isMobileView) {
        <ng-template sisExpandableHeaderButtons>
          @if (!props.enrolment && isEnrolmentAllowed()) {
            <sis-button (clicked)="enrolClicked.emit()" size="sm" data-cy="enrol-button">
              {{ "ENROLMENT.ENROL" | translate }}
            </sis-button>
          } @else {
            <span class="title-info guidance" data-cy="enrolment-disabled-guidance">
              {{ "ENROLMENTS.OPEN_UNIVERSITY_ENROLMENT.TEACHING_NOT_SELECTABLE" | translate }}
            </span>
          }
        </ng-template>
      }
      <ng-template sisExpandableContent>
        @if (props.isMobileView) {
          <div class="mb-5">
            @if (!props.enrolment && isEnrolmentAllowed()) {
              <sis-button (clicked)="enrolClicked.emit()" data-cy="enrol-button">
                {{ "ENROLMENT.ENROL" | translate }}
              </sis-button>
            } @else {
              <span class="title-info guidance" data-cy="enrolment-disabled-guidance">
                {{ "ENROLMENTS.OPEN_UNIVERSITY_ENROLMENT.TEACHING_NOT_SELECTABLE" | translate }}
              </span>
            }
          </div>
        }
        <app-course-unit-realisation-info
          [courseUnitRealisation]="courseUnitRealisation"
          [courseUnit]="courseUnit"></app-course-unit-realisation-info>
      </ng-template>
    </sis-expandable>
  }
}
